import { BackSlashIcon, DottedIcon, HomeIcon } from "assests";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

const BreadCrumb = ({ text, textAnother, secondaryLink }) => {
  const { currentWorkspace } = useSelector((state) => state.authenticationSlice);
  const location = useLocation(); // Get current location

  // Check if the current route is "settings"
  const isSettingsRoute = location.pathname.includes("/setting");

  if (isSettingsRoute) return null;
  return (
    <div className="overflow-x-auto">
      <div className="h-7 justify-start items-center inline-flex">
        <div className="justify-start items-center gap-2 flex">
          <div className="p-1">
            <Link to={"/"}>
              {currentWorkspace &&
              currentWorkspace.invited_workspace_name &&
              !currentWorkspace.is_owner ? (
                <DottedIcon strokeColor="#717680" />
              ) : (
                <HomeIcon />
              )}
            </Link>
          </div>
          <div>
            <BackSlashIcon />
          </div>
          {currentWorkspace &&
            currentWorkspace.invited_workspace_name &&
            !currentWorkspace.is_owner && (
              <Link
                className="text-sm font-semibold cursor-pointer leading-5 text-[#181D27] whitespace-nowrap justify-start items-center gap-2 flex"
                to={`/workspace/${currentWorkspace?.workspace_id}/report`}
              >
                {currentWorkspace.invited_workspace_name} <BackSlashIcon />
              </Link>
            )}
          {textAnother && (
            <div
              onClick={secondaryLink}
              className="text-sm font-semibold cursor-pointer leading-5 text-[#181D27] whitespace-nowrap justify-start items-center gap-2 flex"
            >
              {textAnother} <BackSlashIcon />
            </div>
          )}

          <div className="px-1.5 py-0.5 bg-global-theme h-[22px] rounded-md border border-[#D0D5DD] justify-center items-center flex shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]">
            <div className="text-[#414651] whitespace-nowrap text-xs  tracking-[0.005em] font-medium  leading-tight">
              {text}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadCrumb;
